/** Versão atual do xat Ajuda — manter alinhada com `changelogAjuda` (entrada `latest`). */
export const XAT_AJUDA_VERSION = '2.0.0';
